import React, {useState, useEffect, useRef} from "react";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useNavigate } from "react-router-dom";
import InvehicleRecordingsFilterDropdown from "./InvehicleRecordingsFilterDropdown";

const DesktopTabsForInvehicleRecordings= ({setActiveTab, activeTab, filterOpen, setFilterOpen,
    filters, setFilters, onApply, handleResetFilters}) => {

    const filterWrapperRef = useRef(null);
    const navigate = useNavigate();

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
          const isClickInsideWrapper =
            filterWrapperRef.current &&
            filterWrapperRef.current.contains(event.target);
      
          const isClickInsideDatePicker =
            event.target.closest(".MuiPickersPopper-root");
      
          if (!isClickInsideWrapper && !isClickInsideDatePicker) {
            setFilterOpen(false);
          }
        };
      
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
   
    return (
        <div className="hidden lg:flex w-full h-[280px] justify-center items-center 
           bg-[linear-gradient(91deg,_#B05BC5_0%,_#AEAEFD_100%)]"
            >
           <div className="w-[80%] h-fit flex flex-col gap-[60px] mt-[80px]">
                <p className="text-[45px] font-bold text-[#FFFFFF] mt-[20px]"> Lesson Records </p>
                
                <div className="w-full flex justify-between items-end">
                    <div className="w-full flex gap-[50px] 2.5xl:gap-[90px]">
                        <div className="flex flex-col gap-[2px] cursor-pointer">
                            <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                            onClick={() => setActiveTab("LiveRecording")}>
                                Live Recording
                            </p>
                            { activeTab === "LiveRecording" && (
                                <div className="h-[7px] bg-[#FFFFFF]">
                                </div>
                            )}
                        </div>

                        <div className="flex flex-col gap-[2px] cursor-pointer">
                            <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                            onClick={() => setActiveTab("Recorded")}>
                                Recorded
                            </p>
                            { activeTab === "Recorded" && (
                                <div className="h-[7px] bg-[#FFFFFF]">
                                </div>
                            )}
                        </div>

                        <div className="flex flex-col gap-[2px] cursor-pointer">
                            <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                            onClick={() => setActiveTab("SpaceManagement")}>
                                Space Management
                            </p>
                            { activeTab === "SpaceManagement" && (
                                <div className="h-[7px] bg-[#FFFFFF]">
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex gap-[20px] relative">
                        {/* Filter Button + Dropdown */}
                        <div className="relative" ref={filterWrapperRef}>
                            <button
                            className="w-[280px] h-[45px] flex justify-center items-center text-[19px] text-[#174A84] gap-[5px] cursor-pointer"
                            style={{
                                background: 'transparent linear-gradient(90deg, #AEB0FF 0%, #FFFFFF 50%, #B05AC4 100%) 0% 0% no-repeat padding-box',
                                boxShadow: '0px 3px 6px #00000029',
                                border: '1px solid #E3E3E3',
                                borderRadius: '6px'
                            }}
                            onClick={() => setFilterOpen((prev) => !prev)}
                            >
                                <span>Filter Recordings</span>
                                <span>
                                    {filterOpen ? (
                                    <KeyboardArrowDownIcon style={{ fontSize: "20px", color:"#174A84" }} />
                                    ) : (
                                    <ArrowForwardIosIcon style={{ fontSize: "16px", color:"#174A84" }} />
                                    )}
                                </span>
                            </button>

                            {/* Dropdown */}
                            {filterOpen && (
                                <div className="absolute right-0 top-[50px] z-50">
                                    <InvehicleRecordingsFilterDropdown  filters={filters} setFilters={setFilters} onApply={onApply} handleResetFilters={handleResetFilters} activeTab={activeTab} /> 
                                </div>
                            )}  
                        </div>
                    </div>  
                </div>
           </div>
        </div>
    );
};

export default DesktopTabsForInvehicleRecordings;
